import { Homepage } from "./HomePage";

function InitPage() {

  return (
    <div className="App">
      <Homepage />
    </div>
  );
}

export default InitPage;